import React, { useState } from 'react';
import { Pin, ChevronDown, ChevronUp } from 'lucide-react';
import { formatFullDate } from './chatUtils';

// Pinned messages strip at the top of a channel; click a pin to jump to it
export const PinnedBar = ({ pins, onJump, canModerate, onUnpin }) => {
  const [expanded, setExpanded] = useState(false);
  if (!pins.length) return null;
  const shown = expanded ? pins : pins.slice(0, 1);
  return (
    <div className="border-b border-amber-900/40 bg-amber-950/15 shrink-0" data-testid="pinned-bar">
      {shown.map((p) => (
        <div key={p.id} className="flex items-start gap-2 px-4 py-2 group/pin">
          <Pin className="w-3.5 h-3.5 text-amber-500 mt-0.5 flex-shrink-0" />
          <button onClick={() => onJump(p)} className="flex-1 min-w-0 text-left" data-testid={`pin-item-${p.id}`} title={formatFullDate(p.createdAt)}>
            <span className="font-headline text-[11px] tracking-wide text-amber-400 mr-2">{p.sender?.displayName || 'Unknown'}</span>
            <span className="text-xs text-zinc-300 truncate inline-block max-w-full align-bottom">{p.content}</span>
          </button>
          {canModerate && (
            <button onClick={() => onUnpin(p.id)} className="opacity-0 group-hover/pin:opacity-100 text-[10px] font-typewriter text-zinc-500 hover:text-red-400 transition-opacity" data-testid={`unpin-${p.id}`}>unpin</button>
          )}
          {pins.length > 1 && p === shown[0] && (
            <button onClick={() => setExpanded((e) => !e)} className="text-zinc-500 hover:text-amber-400 flex items-center gap-0.5 text-[10px] font-typewriter" data-testid="pinned-toggle">
              {pins.length}{expanded ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default PinnedBar;
